// import axios from "axios";

// const uploadImageTos3 = (url, formData) => {
//   debugger;
//   return axios({
//     method: "post",
//     url: `${url}`,

//     headers: { "Content-Type": "multipart/form-data" }
//   });
// };

// export default uploadImageTos3;

import axios from "axios";

const uploadImageTos3 = (url, file) => {
  return axios({
    method: "put",
    url: `${url}`,
    data: file,
    headers: {
      "Content-Type": `${file.type}`
    }
  });
};

export default uploadImageTos3;



// WEBPACK FOOTER //
// ./src/utilities/imageUploader.js